module.exports = __webpack_public_path__ + "img/facebook.09e85409.png";